var rtl_default = {
  "rtl": "kNtUq",
  "ltr": "waX3Z"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
